import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { CompanyImage, PagedResult } from '../../models';


export interface ICompanyImageService {

	get(companyId: string, imageId: string): Promise<CompanyImage>;
	list(companyId: string): Promise<CompanyImage[]>;
	page(companyId: string, pageIndex: number, pageSize: number): Promise<PagedResult<CompanyImage>>;
	save(image: CompanyImage): Promise<CompanyImage>;
	delete(companyId: string, imageId: string): Promise<any>;
	revert(companyId: string): Promise<any>;

}

@injectable()
export class CompanyImageService implements ICompanyImageService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(companyId: string, imageId: string): Promise<CompanyImage> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/images/${imageId}`;
		return this.httpClient.get<CompanyImage>(url);
	}

	public list(companyId: string): Promise<CompanyImage[]> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/images`;
		return this.httpClient.get<CompanyImage[]>(url);
	}

	public page(companyId: string, pageIndex: number, pageSize: number): Promise<PagedResult<CompanyImage>> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/images/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<CompanyImage>>(url);
	}

	public save(image: CompanyImage): Promise<CompanyImage> {
		let url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${image.companyId}/images`;
		if (image.id !== null && image.id !== undefined && image.id !== '') {
			url += `/${image.id}`;
			return this.httpClient.put(url, image);
		}
		return this.httpClient.post(url, image);
	}

	public delete(companyId: string, imageId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/images/${imageId}`;
		return this.httpClient.delete(url);
	}

	public revert(companyId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/images/revert`;
		return this.httpClient.post(url, null);
	}

}
